import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { submitBillingDetails } from "../../../../../api/Api";
import { getFromLocalStorage } from "../../../../../utils/common-utils";

const EditBilling = ({ editData, onUpdate }) => {
  const [billingData, setBillingData] = useState({
    serviceType: "Normal",
    packType: "",
    renewalType: "",
    pricePoint: "",
    graceDuration: "",
    suspensionPeriod: "",
    parking: "",
    billingType: "",
    freeTrialDuration: "",
    validity: "",
    chargingCarryForward: "no",
    eventId: "552", // Static value as per payload
  });

  useEffect(() => {
    if (editData) {
      setBillingData(prev => ({
        ...prev,
        ...editData,
        serviceType: "Normal" // Ensure this remains default
      }));
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBillingData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setBillingData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        serviceId: editData?.serviceId,
        id: editData?.id,
        billingType: billingData.billingType,
        renewalType: billingData.renewalType,
        packType: billingData.packType,
        graceDuration: billingData.graceDuration,
        chargingCarryForward: billingData.chargingCarryForward,
        validity: billingData.validity,
        pricePoint: billingData.pricePoint,
        eventId: billingData.eventId,
        freeTrialDuration: billingData.freeTrialDuration,
        suspensionPeriod: billingData.suspensionPeriod,
        parking: billingData.parking,
        maxChargePerDay: null,
        consentChannel: null,
        subRetry: null,
      };

      const response = await submitBillingDetails(payload);

      if (response?.statusDescription?.status === 200) {
        onUpdate(response.productModel);
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description || "Billing details updated successfully!",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response?.statusDescription?.description || "Failed to update billing details",
        });
      }
    } catch (error) {
      console.error("Error updating billing details:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to update billing details",
      });
    }
  };

  return (
    <div className="tab-content-section">
      {/* <div className="tab-content"> */}
        <div className="tab-pane active">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>
                    Service Type<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value="Normal"
                    disabled
                  />
                {/* </div> */}
              </div>
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>
                    Pack Type<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="packType"
                    value={billingData.packType}
                    onChange={handleChange}
                  >
                    <option value="">Select Pack Type</option>
                    <option value="Daily">Daily</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Yearly">Yearly</option>
                  </select>
                  
                {/* </div> */}
              </div>
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>
                    Renewal Type<span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <select
                      className="form-select"
                      name="renewalType"
                      value={billingData.renewalType}
                      onChange={handleChange}
                    >
                      <option value="">Select Renewal Type</option>
                      <option value="autoRenewal">Auto Renewal</option>
                      <option value="manualRenewal">Manual Renewal</option>
                    </select>
                    
               
                  </div>
                {/* </div> */}
              </div>
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>
                    Price<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="pricePoint"
                    value={billingData.pricePoint}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && 
                          value >= 0 && 
                          value.toString().length <= 6)) {
                        handleChange(e);
                      }
                    }}
                    onKeyPress={(e) => {
                      if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                        e.preventDefault();
                      }
                    }}
                    min="0"
                    max="999999"
                    placeholder="Enter Price"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div> */}
                            <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>
                    Price<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="pricePoint"
                    value={billingData.pricePoint}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Simple validation to allow decimals and prevent values over 999999
                      if (value === '' || (parseFloat(value) >= 0 && parseFloat(value) <= 999999)) {
                        handleChange(e);
                      }
                    }}
                    step="0.01"
                    min="0"
                    max="999999"
                    placeholder="Enter Price"
                    onWheel={(e) => e.target.blur()}
                  />
                {/* </div> */}
              </div>
            </div>

            <div className="row mt-3">
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>
                    Grace Duration(In Days)<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="graceDuration"
                    value={billingData.graceDuration}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (
                        Number.isInteger(Number(value)) && 
                        value >= 0 && 
                        value.toString().length <= 4
                      )) {
                        handleChange(e);
                      }
                    }}
                    onKeyPress={(e) => {
                      if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                        e.preventDefault();
                      }
                    }}
                    min="0"
                    max="9999"
                    placeholder="Enter Grace Duration"
                    onWheel={(e) => e.target.blur()}
                  />
                {/* </div> */}
              </div>
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>
                    Suspension Period<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="suspensionPeriod"
                    value={billingData.suspensionPeriod}
                    onChange={handleChange}
                  >
                    <option value="">Select Suspension Period</option>
                    <option value="3Days">3 Days</option>
                    <option value="7Days">7 Days</option>
                  </select>
                 
                {/* </div> */}
              </div>
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>
                    Parking(In Days)<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="parking"
                    value={billingData.parking}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (
                        Number.isInteger(Number(value)) && 
                        value >= 0 && 
                        value.toString().length <= 4
                      )) {
                        handleChange(e);
                      }
                    }}
                    onKeyPress={(e) => {
                      if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                        e.preventDefault();
                      }
                    }}
                    min="0"
                    max="9999"
                    placeholder="Enter Parking Days"
                    onWheel={(e) => e.target.blur()}
                  />
                {/* </div> */}
              </div>
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>
                    Billing Type<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="billingType"
                    value={billingData.billingType}
                    onChange={handleChange}
                  >
                    <option value="">Select Billing Type</option>
                    <option value="Package">Package</option>
                    <option value="Usage">Usage</option>
                  </select>
                  
                {/* </div> */}
              </div>
            </div>

            <div className="row mt-3">
             
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>Free Trial Duration(In Days)</label>
                  <input
                    type="number"
                    className="form-select"
                    name="freeTrialDuration"
                    value={billingData.freeTrialDuration}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (
                        Number.isInteger(Number(value)) && 
                        value >= 0 && 
                        value.toString().length <= 4
                      )) {
                        handleChange(e);
                      }
                    }}
                    onKeyPress={(e) => {
                      if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                        e.preventDefault();
                      }
                    }}
                    min="0"
                    max="9999"
                    placeholder="Enter Free Trial Duration"
                    onWheel={(e) => e.target.blur()}
                  />
                {/* </div> */}
              </div>
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>
                    Validity(In Days)<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="validity"
                    value={billingData.validity}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (
                        Number.isInteger(Number(value)) && 
                        value >= 0 && 
                        value.toString().length <= 4
                      )) {
                        handleChange(e);
                      }
                    }}
                    onKeyPress={(e) => {
                      if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                        e.preventDefault();
                      }
                    }}
                    min="0"
                    max="9999"
                    placeholder="Enter Validity"
                    onWheel={(e) => e.target.blur()}
                  />
                {/* </div> */}
              </div>
              <div className="form-group col-md-3">
                {/* <div className="form-group"> */}
                  <label>Carry Forward Charging</label>
                  <div className="mt-2">
                    <input
                      type="radio"
                      name="chargingCarryForward"
                      value="yes"
                      checked={billingData.chargingCarryForward === "yes"}
                      onChange={handleRadioChange}
                    />{" "}
                    Yes
                    <input
                      type="radio"
                      name="chargingCarryForward"
                      value="no"
                      checked={billingData.chargingCarryForward === "no"}
                      onChange={handleRadioChange}
                      className="ml-3"
                    />{" "}
                    No
                  </div>
                {/* </div> */}
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12 buttons_divs">
                <button
                  type="submit"
                  className="btn btn-primary float-right"
                >
                  Update Billing Details
                </button>
              </div>
            </div>
          </form>
        </div>
      {/* </div> */}
    </div>
  );
};

export default EditBilling;


